// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3QGkI","brand":"brand__1YCsj","wrapper":"wrapper__-oWEH","logo":"logo__35n-0"};